module.exports = __webpack_public_path__ + "static/img/home_productcard_cooler.0899730c.jpg";